import { render } from "./getComponies.vue?vue&type=template&id=0b1fd6d9"
import script from "./getComponies.vue?vue&type=script&lang=js"
export * from "./getComponies.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__